import { render } from "./userDD.vue?vue&type=template&id=a6c39810&ts=true"
import script from "./userDD.vue?vue&type=script&lang=ts"
export * from "./userDD.vue?vue&type=script&lang=ts"

import "./userDD.vue?vue&type=style&index=0&id=a6c39810&lang=scss"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__